import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import {
  SolutionInfoWrapperSpacing,
  SolutionInfoWrapper,
} from "./SolutionInfo.styled";

import { priceTypes } from "@utils/constants";

import SolutionData from "./SolutionData";

const SolutionInfo = (props) => {
  const {
    t,
    priceType,
    centre,
    supplier,
    haulier,
    product,
    treatmentPrice,
    transportPrice,
    treatmentTransportPrice,
    transportType,
  } = props;
  return (
    <>
      <SolutionInfoWrapper>
        <SolutionInfoWrapperSpacing>
          {priceType === priceTypes.TransportOnly && (
            <SolutionData
              title={t("HAULIER")}
              text={haulier.name}
              url={`/company/view/${haulier.id}/general-info`}
            />
          )}
          {priceType !== priceTypes.TransportOnly && (
            <>
              <SolutionData
                title={t("CENTER")}
                text={centre.name}
                url={`/company/view/${centre.id}/general-info`}
              />
              <SolutionData
                title={t("SUPPLIER")}
                text={supplier.name}
                url={`/company/view/${supplier.id}/general-info`}
              />
            </>
          )}
        </SolutionInfoWrapperSpacing>
        {priceType !== priceTypes.TransportOnly && (
          <SolutionInfoWrapperSpacing>
            <SolutionData title={t("PRODUCT")} text={product} />
            <SolutionData title={t("TRANSPORT_TYPE")} text={transportType} />
          </SolutionInfoWrapperSpacing>
        )}
        <SolutionInfoWrapperSpacing>
          {(priceType === priceTypes.TransportTreatmentSeparated ||
            priceType === priceTypes.TreatmentOnly) && (
            <SolutionData title={t("TREATMENT_PRICE")} text={treatmentPrice} />
          )}
          {(priceType === priceTypes.TransportTreatmentSeparated ||
            priceType === priceTypes.TransportOnly) && (
            <SolutionData title={t("TRANSPORT_PRICE")} text={transportPrice} />
          )}
          {priceType === priceTypes.TransportTreatment && (
            <SolutionData
              title={t("TREATMENT_TRANSPORT_PRICE")}
              text={treatmentTransportPrice}
            />
          )}
        </SolutionInfoWrapperSpacing>
      </SolutionInfoWrapper>
    </>
  );
};

SolutionInfo.propTypes = {
  priceType: PropTypes.number.isRequired,
  centre: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  supplier: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  haulier: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  treatmentPrice: PropTypes.string,
  transportPrice: PropTypes.string,
  treatmentTransportPrice: PropTypes.string,
  product: PropTypes.string,
  transportType: PropTypes.string,
  t: PropTypes.func.isRequired,
};

SolutionInfo.defaultProps = {
  centre: {
    id: null,
    name: "",
  },
  supplier: {
    id: null,
    name: "",
  },
  haulier: {
    id: null,
    name: "",
  },
  treatmentPrice: "",
  transportPrice: "",
  treatmentTransportPrice: "",
  product: "",
  transportType: "",
};

export default withTranslation()(SolutionInfo);
